import { v4 as uuidv4 } from 'uuid';

export function SellerBody(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerBody',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
